var map = {
	"./404.svg": 1271,
	"./bug.svg": 1272,
	"./chart.svg": 1273,
	"./clipboard.svg": 1274,
	"./component.svg": 1275,
	"./drag.svg": 1276,
	"./email.svg": 1277,
	"./example.svg": 1278,
	"./excel.svg": 1279,
	"./eye.svg": 1280,
	"./form.svg": 1281,
	"./icon.svg": 1282,
	"./lock.svg": 1283,
	"./password.svg": 1284,
	"./people.svg": 1285,
	"./qq.svg": 1286,
	"./star.svg": 1287,
	"./tab.svg": 1288,
	"./table.svg": 1289,
	"./theme.svg": 1290,
	"./trendChart1.svg": 1291,
	"./trendChart2.svg": 1292,
	"./trendChart3.svg": 1293,
	"./user.svg": 1294,
	"./wechat.svg": 1295,
	"./zip.svg": 1296
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1623;


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 1623
// module chunks = 1